var _ = require('underscore');
var Marionette = require('marionette');
var Dropdown = require('Dropdown');
var Entities = require('Entities');
var Resources = EY.Consultation.Resources;
var User = EY.Consultation.CurrentUser;

var Layout = Marionette.View.extend({
    modelEvents: {
        'change': 'filter'
    },
    regions: {
        country: '#country',
        recordType: '#recordType'
    },
    template: '#questionnairesFilter',
    filter: function () {
        var queries = this.options.queries;
        var filter = queries.get('default').get('filter');
        _.extend(filter, { geographyId: { $regex: User.adminGeography } });
        _.extend(filter, this.model.get('recordType') ? { recordTypeId: this.model.get('recordType') } : '');
        _.extend(filter, this.model.get('country') ? { geographyId: this.model.get('country') } : '');
        queries.get('default').set('selected', false).set({ filter: filter, selected: true });
    }
});

module.exports.show = function (options) {
    var region = options.region;
    var model = new Backbone.Model();
    var layout = new Layout(_.extend({}, options, { model: model }));

    region.show(layout);
    Dropdown.show({
        collection: new Entities.Geographies(Resources.CountriesFiltered.filter(function (item) {
            return User.roles && User.roles.length > 0 && new RegExp(User.adminGeography).test(item.id);
        })),
        region: layout.getRegion('country'),
        tooltip: true,
        onSelectionChanged: function (country) {
            model.set('country', country.id);
        }
    });
    Dropdown.show({
        collection: new Entities.Enumerations(_.filter(Resources.Enumeration, { type: 'RecordType' })),
        region: layout.getRegion('recordType'),
        tooltip: true,
        resourceKeyAttribute: 'id',
        onSelectionChanged: function (recordType) {
            model.set('recordType', recordType.id);
        }
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Questionnaire/QuestionnairesFilter.js